module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "longpress",
      rawName: "v-longpress",
      value: (_vm.longPressHandler),
      expression: "longPressHandler"
    }],
    staticClass: "page",
    attrs: {
      "data-loaded": "false",
      "id": _vm.pageContainerId,
      "data-page-number": "pageNumber"
    },
    on: {
      "mousedown": _vm.startDrag,
      "touchstart": _vm.startDrag,
      "mousemove": _vm.drag,
      "touchmove": _vm.drag,
      "mouseup": _vm.endDrag,
      "touchend": _vm.endDrag,
      "mouseout": _vm.stopDrag,
      "dblclick": _vm.handleDoubleClick,
      "contextmenu": function($event) {
        return _vm.preventContext($event)
      }
    }
  }, [_c('div', {
    staticClass: "canvasWrapper",
    class: {
      'hide-text-layer': _vm.isTextLayerHidden()
    },
    on: {
      "focusin": _vm.onCanvasFocus,
      "focusout": _vm.onCanvasBlur
    }
  }, [_c('canvas', {
    attrs: {
      "id": ("page" + _vm.pageNumber),
      "tabindex": "0",
      "height": _vm.pageHeight,
      "width": _vm.pageWidth
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textLayer",
    class: {
      'hide-text-layer': _vm.isTextLayerHidden()
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b2f441d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/pdf-page.vue
// module id = 1201
// module chunks = 21